import { Message } from 'components/message'

export class AdicionarCestaObserver {
    constructor() {
        this.navBarElement = document.querySelector('.navbar')
        this.cestaElement = document.querySelector('.navbar__menu-item--cart')
        this.cestaQuantidadeElement = this.cestaElement.querySelector('span')
    }

    next(res) {
        if(res != null) {
            const carrinho = res.carrinho;
            if(carrinho.itensCarrinhoCompra) {
                if(this.navBarElement.classList.contains('scrolled'))
                    this.navBarElement.classList.remove('scrolled')

                setTimeout(() => {
                    this.cestaElement.classList.add('navbar__menu-item--updated')
                    this.cestaQuantidadeElement.innerText = carrinho.itensCarrinhoCompra.length
                }, 100)

                setTimeout(() => {
                    this.cestaElement.classList.add('navbar__menu-item--pulse')
                    this.cestaQuantidadeElement.innerText = carrinho.itensCarrinhoCompra.length
                }, 0)

                setTimeout(() => {
                    this.cestaElement.classList.remove('navbar__menu-item--pulse')
                }, 1300)
            }
        }
    }

    error(error) {
        const msg = (error && error.status && (error.status == 404 || error.status == 400)) ? error.data.mensagem : "Não foi possível adicionar este item no carrinho"
        new Message(msg)
    }

    complete() {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cesta/adicionar/adicionarCesta.observer.js